import {calcHueForPositionsHEX} from "../teams/Teams";

export default function findColorForUser(userId, teams){
    let color = "#fff";

    for(let x in teams){
        const t = teams[x];
        const {leader, technician1, technician2} = t;
        let position = -1;

        if(leader && leader.id === userId)
            position = 0;
        if(technician1 && technician1.id === userId)
            position = 1;
        if(technician2 && technician2.id === userId)
            position = 2;

        if(position > -1){
            const {h,s,l,Lstep} = calcHueForPositionsHEX(t.color);

            color = "hsl("+h+","+s+"%,"+(l+Lstep*position)+"%)";

            break ;
        }
    }


    return color;
}